import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a1364d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = {
  target: "_blank",
  href: "https://www.emerture.co.uk"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid container",
  id: "kt_create_account_stepper",
  ref: "verticalWizardRef"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center bg-white rounded justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9\" data-v-4a1364d2><div style=\"padding-left:0 !important;\" class=\"px-6 px-lg-10 px-xxl-15 py-20 d-lg-block d-none\" data-v-4a1364d2><div class=\"stepper-nav\" data-v-4a1364d2><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-4a1364d2><div class=\"stepper-line w-40px\" data-v-4a1364d2></div><div class=\"stepper-icon w-40px h-40px\" data-v-4a1364d2><i class=\"stepper-check fas fa-check\" data-v-4a1364d2></i><span class=\"stepper-number\" data-v-4a1364d2>1</span></div><div class=\"stepper-label\" data-v-4a1364d2><h3 class=\"stepper-title\" data-v-4a1364d2>Investment Thesis</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-4a1364d2><div class=\"stepper-line w-40px\" data-v-4a1364d2></div><div class=\"stepper-icon w-40px h-40px\" data-v-4a1364d2><i class=\"stepper-check fas fa-check\" data-v-4a1364d2></i><span class=\"stepper-number\" data-v-4a1364d2>2</span></div><div class=\"stepper-label\" data-v-4a1364d2><h3 class=\"stepper-title\" data-v-4a1364d2>Notifications</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-4a1364d2><div class=\"stepper-line w-40px\" data-v-4a1364d2></div><div class=\"stepper-icon w-40px h-40px\" data-v-4a1364d2><i class=\"stepper-check fas fa-check\" data-v-4a1364d2></i><span class=\"stepper-number\" data-v-4a1364d2>3</span></div><div class=\"stepper-label\" data-v-4a1364d2><h3 class=\"stepper-title\" data-v-4a1364d2>Industry Sectors</h3></div></div></div></div></div>", 1)
const _hoisted_6 = { class: "d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_7 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_8 = { "data-kt-stepper-element": "content" }
const _hoisted_9 = { "data-kt-stepper-element": "content" }
const _hoisted_10 = { class: "d-flex flex-stack pb-10" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Skip and view Investment Opportunity")
const _hoisted_13 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_15 = ["data-kt-indicator"]
const _hoisted_16 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_18 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_19 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_25 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvestmentTicketSize = _resolveComponent("InvestmentTicketSize")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_IndustrySectors = _resolveComponent("IndustrySectors")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createElementVNode("img", {
          alt: "Logo",
          src: require('@/assets/img/emerture.png'),
          style: {"height":"29px !important"},
          class: "logo mt-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          class: "py-20 w-100 w-xl-700px px-9",
          novalidate: "novalidate",
          id: "kt_create_account_form",
          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args))),
          style: {"padding-right":"0 !important"}
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_InvestmentTicketSize, {
              fromUpdateInvestor: true,
              onFormData: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formDataTemp = $event)),
              formDataTemp: _ctx.formDataTemp
            }, null, 8, ["formDataTemp"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Notifications, {
              onFormData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formDataTemp = $event)),
              formDataTemp: _ctx.formDataTemp
            }, null, 8, ["formDataTemp"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_IndustrySectors, {
              onFormData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formDataTemp = $event)),
              formDataTemp: _ctx.formDataTemp
            }, null, 8, ["formDataTemp"])
          ]),
          (_ctx.wait)
            ? (_openBlock(), _createBlock(_Teleport, {
                key: 0,
                to: _ctx.currentStepIndex == 0 ? '#investment-ticket-size' : (_ctx.currentStepIndex == 1 ? '#notifications' : '#industry-sectors')
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.currentStepIndex == 0)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/investment-opportunity-profile-view?businessId=${_ctx.route.query.businessId}&userToken=${_ctx.route.query.userToken}`,
                          class: "btn btn-lg btn-primary me-3"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_13, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _hoisted_14
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          "data-kt-indicator": _ctx.loading ? 'on' : null,
                          type: "button",
                          class: "btn btn-lg btn-primary me-3",
                          "data-kt-stepper-action": "submit",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit()))
                        }, [
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("span", _hoisted_18, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_22))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_15))
                      : (_openBlock(), _createElementBlock("button", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("span", _hoisted_25, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                  ])
                ])
              ], 8, ["to"]))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ], 512)
  ], 64))
}